import axios from '@/libs/api.request'

//   获取订单列表
export const getfoodOrderList = (data) => {
    return axios.request({
      url: 'foodorder/page',
      data: data,
      method: 'post',
    })
}

// 修改订单状态
export const updateordertype = (data) => {
    return axios.request({
      url: 'foodorder/updateordertype',
      data: data,
      method: 'post',
    })
}

// 管理端：确认订单
export const adminConfirmFoodOrder = (data) => {
  return axios.request({
    url: 'foodorder/admin/confirm',
    data,
    method: 'post',
  })
}

// 管理端：备货/出餐完成
export const adminPickingDoneFoodOrder = (data) => {
  return axios.request({
    url: 'foodorder/admin/picking-done',
    data,
    method: 'post',
  })
}

/** 管理端：取消并退款 */
export const adminCancelAndRefundFoodOrder = (data) => {
  return axios.request({
    url: 'foodorder/admin/cancel-and-refund',
    data,
    method: 'post',
  })
}

/** 管理端：出餐完成后退款 */
export const adminRefundFoodOrder = (data) => {
  return axios.request({
    url: 'foodorder/admin/refund',
    data,
    method: 'post',
  })
}

/** 管理端：同意用户取消 */
export const adminCancelApproveFoodOrder = (data) => {
  return axios.request({
    url: 'foodorder/admin/cancel-approve',
    data,
    method: 'post',
  })
}

/** 管理端：拒绝用户取消 */
export const adminCancelRejectFoodOrder = (data) => {
  return axios.request({
    url: 'foodorder/admin/cancel-reject',
    data,
    method: 'post',
  })
}

/** 管理端：补打前厅/后厨小票 */
export const adminReprintFoodOrder = (data) => {
  return axios.request({
    url: 'print-agent/admin/reprint',
    data,
    method: 'post',
  })
}